var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 19.406 4.962 11 13 2.594 10.52 0 0 11l10.52 11L13 19.406z"
  })));
};
export default SvgChevronLeft;